// Calendário de eventos do servidor (proposta; o design deixou o calendário em aberto).
// Fins de semana do mês (sábado e domingo, horário de Brasília) com os eventos de bônus do Tibia:
// 1º Rapid Respawn (respawn 5x mais rápido, sem bosses) · 2º Double Loot · 3º Double Skill · 4º Double Experience.
// Num 5º fim de semana, todos juntos (fim de mês festivo). Eventos sazonais com nome do Tibia só como tema do mês.

export type EventKind = 'respawn' | 'loot' | 'skill' | 'xp';
export const EVENT_INFO: Record<EventKind, { name: string; desc: string }> = {
  respawn: { name: 'Rapid Respawn', desc: 'Monstros reaparecem 5x mais rápido (não vale para bosses).' },
  loot: { name: 'Double Loot', desc: 'Chance de loot dobrada nas criaturas comuns.' },
  skill: { name: 'Double Skill', desc: 'Treino de skills e magic level em dobro.' },
  xp: { name: 'Double Experience', desc: 'Experiência em dobro em todas as criaturas.' },
};
const ORDER: EventKind[] = ['respawn', 'loot', 'skill', 'xp'];

/** data no horário de Brasília (UTC-3) */
const br = (now: number) => new Date(now - 3 * 3600_000);

/** eventos de um dia (ano, mês 0-11, dia) */
export function eventsOn(y: number, m: number, d: number): EventKind[] {
  const dt = new Date(Date.UTC(y, m, d));
  const wd = dt.getUTCDay();
  if (wd !== 6 && wd !== 0) return [];
  let sat = wd === 6 ? d : d - 1;   // o sábado deste fim de semana
  if (sat < 1) sat += new Date(Date.UTC(y, m, 0)).getUTCDate();   // domingo dia 1: o fim de semana começou no mês anterior
  const n = Math.floor((sat - 1) / 7);   // 0 = primeiro sábado do mês
  return n < 4 ? [ORDER[n]!] : [...ORDER];
}
export function activeEvents(now = Date.now()): EventKind[] {
  const t = br(now);
  return eventsOn(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate());
}
/** tema sazonal do mês (eventos do Tibia), só como nome */
export const MONTH_THEME = ['The First Dragon', 'Valentine', 'Orcsoberfest', 'Chyllfroest', 'Flower Month', 'Flower Month', 'Summer',
  'The Great Expedition', 'Rise of Devovorga', 'Halloween', 'The Lightbearer', 'Christmas'];

export const EVENT_XP_MULT = 2;
export const EVENT_LOOT_MULT = 2;
export const EVENT_SKILL_MULT = 2;
export const EVENT_RESPAWN_DIV = 5;

/** Taxa de loot do servidor (decisões do Arthur, 14/10): monstros de hunt dão 2,5x a chance de cada item e 2,5x o gold. Bosses ficam de fora. */
export const SERVER_LOOT_RATE = 2.5;
export const SERVER_GOLD_RATE = 2.5;
